<div class="kontainer">
  <div class="tråder">
    <div class="utvalg">
      <mat-tab-group [(selectedIndex)]="utvalg" data-tips-id="kommentar-velger">
        <mat-tab label="{{ 'Mine'|translate }}"></mat-tab>
        <mat-tab label="{{ 'Andres'|translate }}"></mat-tab>
      </mat-tab-group>
    </div>

    <div class="grupper">
      @for (gruppe of grupper(); track gruppe.dato) {
        <div class="gruppe">
          <div class="gruppetittel">{{ gruppe.dato | plaindate:{month: 'long'} }} {{ gruppe.dato.year }}</div>
          @for (traad of gruppe.traader; track traad.id) {
            <div class="kommentar e2e-kommentar-i-liste" [ngClass]="{'valgt':valgtKommentar() == traad}" (click)="setValgt(traad)" data-tips-id="kommentar-traad">
              <div class="forfatter e2e-kommentar-deltakere">
                <avatar [medlem]="traad.publisertAv" stil="liten"/>
                @if (traad.privat) {
                  <i class="lederplan-ikon-eye-off-outline"></i>
                  <span class="privat"
                        matTooltip="{{'Denne kommentaren er privat og dermed kun synlig for deg'|translate}}">
                    {{ 'Privat'|translate }}
                  </span>
                } @else {
                  <span class="informerte">
                    <i class="std-ikon ion-ios-arrow-thin-right"></i>
                    @for (medlem of varsledeEksTraadForfatter(traad); track medlem.id) {
                      <avatar [medlem]="medlem" stil="liten"/>
                    }
                  </span>
                }
              </div>
              <div class="tekst e2e-kommentar-tekst" [innerHTML]="traad.kommentar | linky"></div>
              <div class="metainformasjon">
                <foreldersti [forelder]="traad.forelder" [klikkbar]="false" class="e2e-kommentar-kontekst"/>
                <div>
                  {{'{antall} svar, siste publisering {dato}'|translate:{antall: traad.svar.length, dato: traad.senestePubliseringsdato | zoneddatetime} }}
                  <avatar [medlem]="senestePublisertAv(traad)" stil="mini"/>
                </div>
              </div>

            </div>
          }
          @if (gruppe.traader.length == 0) {
            <div class="ingen-kommentarer">{{ 'Ingen kommentarer..'|translate }}</div>
          }
        </div>
      }
    </div>
    <div class="last-flere">
      <button mat-button color="primary" (click)="lastFlere()" [disabled]="laster()" [visSpinner]="laster()" spinnerTekst="{{'laster...'|translate}}">
        {{'Vis flere måneder'|translate}}
      </button>
    </div>
  </div>

  <div class="innhold e2e-aktiv-kommentar">
    <div class="kommentarkontainer">
      @if (valgtKommentar()) {
        <foreldersti [forelder]="valgtKommentar()!.forelder" class="e2e-kommentar-kontekst">
          {{ 'Kommentartråd tilknyttet'|translate }}
        </foreldersti>
        <kommentar-traad [traad]="valgtKommentar()!"/>
      }
    </div>
  </div>
</div>
